import { createTheme } from "@mui/material/styles";

const theme = createTheme({
    palette: {
        mode: "light",
        primary: {
            main: "#FF8300",
        },
        secondary: {
            main: "#FF83001F",
            light: "#FFFCF7",
            contrastText: "#EB92211F",
            header: "#FFF0E6",
        },
        error: {
            main: "#EF3D30",
            dark: "#C62828",
        },
        warning: {
            main: "#E68624",
            light: "#E6B71E",
        },
        success: {
            main: "#2E7D32",
            dark: "#2C847D",
            light: "#66BB6A"
        },
        info: {
            main: "#1976D2"
        },
        custom: {
            white: "#FFFFFF",
            black: "#000000",
            gray: "#222222",
            lightGray: "#40424D"
        },
        border: {
            light: "#55555533",
            dark: "#11111133",
        },
        background: {
            default: "#FFFFFF",
            paper: "#F4F4F4"
        },
    },
    typography: {
        fontFamily: "Satoshi",
    },
});

export default theme;
